import { useEffect, useRef, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import useOutsideClick from "../../../hooks/useOutsideClick";
import React from "react";

export type FindCheckBoxListProps = {
    children: Array<React.ReactElement>;
    enabledButton: boolean;
    id: number;
    history?: string[] | undefined;
    label: string;
    onChange: (searchField: string) => void;
};

const FindCheckBoxList = (props: FindCheckBoxListProps) => {
    const divRef = useRef<HTMLDivElement>(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchResults, setSearchResults] = useState(props.children);
    const [selectedItems, setSelectedItems] = useState<Set<string>>(new Set());
    const [placeholder, setPlaceholder] = useState("Search");
    const inputRef = useRef<HTMLInputElement>(null);
    const [SelectedLabel, setSelectedLabel] = useState<Array<string>>([]);
    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        if (props.history && props.history?.length > 0) {
            let test = props.history[0];
            if (test.includes(";")) {
                const numberSet = new Set(test.split(";").filter(Boolean));
                setSelectedItems(numberSet);
            }
        }
    }, [props.history]);

    const handleSearch = (value: string) => {
        setSearchValue(value);
        if (value.length > 2) {
            setSearchResults(
                props.children.filter((mb: React.ReactElement) => {
                    const text = mb?.props?.children?.props?.children;
                    return typeof text === "string" && text.toLowerCase().includes(value.toLowerCase());
                }),
            );
        } else {
            setSearchResults(props.children);
        }
    };

    const toggleItem = (index: string) => {
        setSelectedItems(prev => {
            const newSet = new Set(prev);
            newSet.has(index) ? newSet.delete(index) : newSet.add(index);

            const selectedValues = Array.from(newSet);
            const values = selectedValues.join(";");

            props.onChange(values);
            setSelectedLabel(getLabelsFromValues(newSet));

            return newSet;
        });
    };

    const getLabelsFromValues = (values: Set<string>): string[] => {
        const labels: string[] = [];

        props.children.forEach((item: React.ReactElement) => {
            const key = String(item.key);
            if (values.has(key)) {
                labels.push(item.props?.children?.props?.children);
            }
        });
        return labels;
    };
    const onOutsideClick = () => {
        setDropdownOpen(false);
    };
    useOutsideClick(divRef, onOutsideClick);
    return (
        <div
            className={"CheckBoxList-dropdown" + (dropdownOpen ? "-selected" : "")}
            key={props.id}
            ref={divRef}
            style={{ width: "100%" }}
        >
            <button
                tabIndex={0}
                onClick={() => setDropdownOpen(o => !o)}
                disabled={!props.enabledButton}
                className={"" + (props.enabledButton ? "CheckBoxList-buttonEnabled" : "")}
                style={{ textAlign: "left" }}
                title={SelectedLabel.length > 0 ? SelectedLabel.join(", ") : "Select mailbox"}
            >
                <span
                    style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        flexGrow: 1,
                    }}
                >
                    {SelectedLabel.length > 0 ? SelectedLabel.join(", ") : "Select mailbox"}
                </span>
                <BsChevronDown style={{ fontSize: "10px", float: "right", flexShrink: 0, marginTop: "5px" }} />
            </button>

            {dropdownOpen && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: 1000,
                        backgroundColor: "white",

                        width: "312px",
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        padding: "5px",
                        marginLeft: "0px",
                    }}
                >
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        style={{
                            border: "solid 1px #888",
                            width: "90%",
                            fontSize: "13px",
                            marginBottom: "5px",
                            marginLeft: "5px",
                            backgroundColor: "white",
                            color: "black",
                            paddingLeft: "8px",
                        }}
                        autoComplete="off"
                        placeholder={placeholder}
                        onChange={e => handleSearch(e.target.value)}
                        onFocus={() => setPlaceholder("")}
                        onBlur={() => setPlaceholder("Search")}
                        ref={inputRef}
                        value={searchValue}
                    />

                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                        {searchResults.map((child, index) => (
                            <li key={index}>
                                <label
                                    style={{ display: "flex", alignItems: "center", backgroundColor: "transparent" }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedItems.has(child?.key !== null ? (child.key as string) : "-1")}
                                        onChange={() => toggleItem(child?.key !== null ? (child.key as string) : "-1")}
                                        className="FindCheckbox"
                                        style={{
                                            marginRight: "8px",
                                            marginLeft: "5px",
                                            marginBottom: "6px",
                                        }}
                                    />
                                    <div
                                        onClick={() => {
                                            selectedItems.has(child?.key !== null ? (child.key as string) : "-1");
                                            toggleItem(child?.key !== null ? (child.key as string) : "-1");
                                        }}
                                    >
                                        {child}
                                    </div>
                                </label>
                            </li>
                        ))}{" "}
                        {searchResults.length === 0 && (
                            <div style={{ textAlign: "center", marginTop: "15px" }}>
                                <span>
                                    No Results found for "{inputRef.current?.value}" <br />
                                    Please try another search term.
                                </span>
                            </div>
                        )}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default FindCheckBoxList;
